<button type="button" class="btn-impressao" (click)="onClick()" [disabled]="disabled">
<p>Exportar PDF</p>
  <img *ngIf="icon" [src]="icon" alt="Ícone de PDF" />
</button>
